import BlockSpotlight from './spotlight'

export default BlockSpotlight
